{
    "page_header": {
        "title": "Revolutionize Receipts, Elevate Experiences",
        "subtitle": "Experience the Future of Shopping with Effortless Digital Receipts. Empowering Businesses, Delighting Customers, Join the Future of Shopping Today!",
        "image": "https://receeto.com/assets/fake-db/images/home_header.webp"
    },
    "sections": [
        {
            "section_id": "home_features_for_shoppers",
            "title": "Unleash the Power of Digital Receipts",
            "subtitle": "",
            "image": null,
            "articleLists": [
                {
                    "id": 1,
                    "title": null,
                    "articles": [
                        {
                            "id": 1,
                            "title": "Instant Receipts",
                            "subtitle": "",
                            "description": "Say goodbye to paper receipts. Instantly receive digital receipts on your phone right after your purchase. No more hassles, just seamless transactions.",
                            "image": "https://receeto.com/assets/fake-db/images/home_shopper_feature_01.webp"
                        },
                        {
                            "id": 2,
                            "title": "Smart Expense Tracking",
                            "subtitle": "",
                            "description": "Keep tabs on your spending effortlessly. Our app organizes your digital receipts, allowing you to track and manage your expenses with ease. Stay in control of your finances.",
                            "image": "https://receeto.com/assets/fake-db/images/home_shopper_feature_02.webp"
                        },
                        {
                            "id": 3,
                            "title": "Personalized Offers",
                            "subtitle": "",
                            "description": "Enjoy a personalized shopping experience. Based on your preferences and purchase history, our app brings you exclusive offers and deals. It's shopping tailored to your taste.",
                            "image": "https://receeto.com/assets/fake-db/images/home_shopper_feature_03.webp"
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "home_features_for_sellers",
            "title": null,
            "subtitle": "",
            "image": "https://receeto.com/assets/fake-db/images/home_seller_feature.webp",
            "articleLists": [
                {
                    "id": 2,
                    "title": null,
                    "articles": [
                        {
                            "id": 1,
                            "title": "Intelligent Customer Insights",
                            "subtitle": "Empower Your Business with Digital Receipts",
                            "description": "Gain a deeper understanding of your customers with our intelligent customer insights. Our solution provides valuable data on customer preferences, purchase history, and engagement patterns. Unlock the power of personalized marketing strategies to elevate your business and build lasting customer relationships."
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "home_how_it_works",
            "title": "Seamless Integration, Effortless Experience",
            "subtitle": "",
            "image": null,
            "articleLists": [
                {
                    "id": 3,
                    "title": "For Shoppers",
                    "articles": [
                        {
                            "id": 4,
                            "title": "Shop and Scan",
                            "subtitle": "It’s Just One Scan Away",
                            "description": "Make your purchases as usual. After completing your transaction, provide your unique ID or QR code to the cashier, who effortlessly scans it using our app.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_shoppers_01.webp"
                        },
                        {
                            "id": 5,
                            "title": "Instant Digital Receipt",
                            "subtitle": "Receipts at Your Fingertips",
                            "description": "Experience the magic of instant digital receipts. As soon as the cashier scans your ID or QR code, receive a real-time notification with your digital receipt securely stored in the app.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_shoppers_02.webp"
                        },
                        {
                            "id": 6,
                            "title": "Personalized Convenience",
                            "subtitle": "Savings Hub",
                            "description": "Unlock personalized offers and effortlessly manage your expenses. Access your digital receipts anytime, explore exclusive deals, and enjoy a shopping experience tailored to your preferences.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_shoppers_03.webp"
                        }
                    ]
                },
                {
                    "id": 4,
                    "title": "For Sellers",
                    "articles": [
                        {
                            "id": 7,
                            "title": "Seamless Integration",
                            "subtitle": "POS Integration Made Easy",
                            "description": "Integrate our solution seamlessly into your Point of Sale (POS) system. Our system plugs into your existing infrastructure, ensuring a smooth and hassle-free experience for you and your customers.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_sellers_01.webp"
                        },
                        {
                            "id": 8,
                            "title": "Customer Data Insights",
                            "subtitle": "Insights for Better Engagement",
                            "description": "Gain valuable insights into customer preferences and behavior. Our system provides intelligent data on purchasing patterns, enabling you to tailor your marketing strategies and enhance customer engagement.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_sellers_02.webp"
                        },
                        {
                            "id": 9,
                            "title": "Streamlined Operations",
                            "subtitle": "Go Paperless with Receeto",
                            "description": "Streamline your operations with digital receipts. Reduce paper waste, efficiently manage transactions, and enjoy the convenience of synchronized data between offline and online modes.",
                            "image": "https://receeto.com/assets/fake-db/images/hiw_sellers_03.webp"
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "home_testimonial",
            "title": "Hear What Our Happy Shoppers Say",
            "subtitle": "",
            "image": null,
            "articleLists": [
                {
                    "id": 5,
                    "title": null,
                    "testimonys": [
                        {
                            "id": 1,
                            "content": "I've never experienced such convenience in shopping before! The digital receipt app is a game-changer. Instant receipts, personalized offers, and effortless expense tracking have simplified my life. Kudos to the team for revolutionizing the way we shop!",
                            "rating": 4,
                            "witnesss": [
                                {
                                    "name": "Naceur Ben SMA",
                                    "profession": "Finance expert",
                                    "avatar": "https://receeto.com/assets/fake-db/images/witness.webp"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "home_latest_blogs",
            "title": "Our latest blogs",
            "subtitle": "",
            "image": null
        }
    ],
    "banners": [
        {
            "id": 1,
            "banner_id": "home_sub_banner_01",
            "title": "Start your 7 days free trial today",
            "subtitle": "Grow your business with Receeto",
            "description": "Subscribe now to our newsletter to be the first one informed about our updates.",
            "image": "https://receeto.com/assets/fake-db/images/home_sub_banner.webp"
        }
    ],
    "latest_blogs": [],
    "reference_section": {
        "section_id": "partners_for_partners",
        "title": "Our Partners, Our Hidden Soldiers",
        "subtitle": "",
        "image": "https://receeto.com/assets/fake-db/images/for_partners.webp",
        "articleLists": [
            {
                "id": 13,
                "title": "Who Are They ?",
                "articles": [
                    {
                        "id": 5,
                        "title": "POS Providers",
                        "description": "Upgrade your offering with digital receipt",
                        "svg_code": "<svg viewBox=\"0 0 49 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                        <path d=\"M42.9173 19H39.8756V0.75H9.45898V19H6.41732C4.80392 19 3.2566 19.6409 2.11575 20.7818C0.974905 21.9226 0.333984 23.4699 0.333984 25.0833V46.375H49.0006V25.0833C49.0006 23.4699 48.3597 21.9226 47.2189 20.7818C46.078 19.6409 44.5307 19 42.9173 19ZM15.5423 6.83333H33.7923V19H15.5423V6.83333ZM42.9173 40.2917H6.41732V25.0833H42.9173V40.2917ZM39.8756 34.2083H27.709V28.125H39.8756V34.2083Z\" fill=\"#7857E6\"/>\r\n                    </svg>"
                    },
                    {
                        "id": 6,
                        "title": "Payment Solutions Providers",
                        "description": "Reach a wider audience in our digital world",
                        "svg_code": "<svg viewBox=\"0 0 52 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                        <path d=\"M42.0261 25.9331C42.0261 26.7222 41.7921 27.4936 41.3537 28.1497C40.9153 28.8058 40.2922 29.3172 39.5632 29.6191C38.8342 29.9211 38.032 30.0001 37.258 29.8462C36.4841 29.6922 35.7732 29.3122 35.2152 28.7543C34.6573 28.1963 34.2773 27.4854 34.1233 26.7115C33.9694 25.9375 34.0484 25.1353 34.3504 24.4063C34.6524 23.6773 35.1637 23.0542 35.8198 22.6158C36.4759 22.1774 37.2473 21.9434 38.0364 21.9434C39.0945 21.9434 40.1093 22.3637 40.8575 23.112C41.6058 23.8602 42.0261 24.875 42.0261 25.9331ZM52.0004 17.9537V37.9022C52.0004 40.0185 51.1597 42.0481 49.6633 43.5445C48.1668 45.041 46.1372 45.8817 44.021 45.8817H8.11358C5.9973 45.8817 3.96771 45.041 2.47128 43.5445C0.974844 42.0481 0.134158 40.0185 0.134158 37.9022V8.20883C0.103468 7.14181 0.287183 6.07948 0.674423 5.08474C1.06166 4.09 1.64456 3.18306 2.38859 2.41764C3.13263 1.65221 4.02268 1.04385 5.00605 0.628575C5.98942 0.213302 7.04612 -0.000440573 8.11358 6.81806e-07H41.0287C41.8223 6.81806e-07 42.5834 0.315258 43.1445 0.876419C43.7057 1.43758 44.021 2.19868 44.021 2.99228C44.021 3.78589 43.7057 4.54698 43.1445 5.10815C42.5834 5.66931 41.8223 5.98456 41.0287 5.98456H8.11358C7.84606 5.98442 7.58125 6.03809 7.3349 6.14237C7.08855 6.24665 6.86569 6.39942 6.67958 6.59158C6.49346 6.78374 6.3479 7.01137 6.25155 7.26093C6.1552 7.51049 6.11003 7.77688 6.11872 8.04425V8.0642C6.16062 8.59239 6.40302 9.08453 6.7962 9.43969C7.18939 9.79485 7.70356 9.98612 8.23327 9.97427H44.021C46.1372 9.97427 48.1668 10.815 49.6633 12.3114C51.1597 13.8078 52.0004 15.8374 52.0004 17.9537ZM46.0158 17.9537C46.0158 17.4246 45.8056 16.9172 45.4315 16.5431C45.0574 16.169 44.55 15.9588 44.021 15.9588H8.23327C7.51985 15.9591 6.80929 15.8686 6.11872 15.6895V37.9022C6.11872 38.4313 6.32889 38.9387 6.703 39.3128C7.07711 39.6869 7.58451 39.8971 8.11358 39.8971H44.021C44.55 39.8971 45.0574 39.6869 45.4315 39.3128C45.8056 38.9387 46.0158 38.4313 46.0158 37.9022V17.9537Z\" fill=\"#7857E6\"/>\r\n                    </svg>"
                    },
                    {
                        "id": 7,
                        "title": "ATM Providers",
                        "description": "Eliminate wasted paper for a sustainable world",
                        "svg_code": "<svg viewBox=\"0 0 54 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                        <path d=\"M29.7751 27.0501H21.6999C20.9372 27.0501 20.2984 27.3085 19.7834 27.8254C19.2683 28.3422 19.0099 28.981 19.0081 29.7419C19.0081 30.5045 19.2665 31.1443 19.7834 31.6611C20.3002 32.1779 20.939 32.4354 21.6999 32.4336H24.3916C24.3916 33.1963 24.65 33.836 25.1668 34.3528C25.6836 34.8696 26.3225 35.1271 27.0833 35.1253C27.846 35.1253 28.4857 34.8669 29.0025 34.3501C29.5194 33.8333 29.7769 33.1945 29.7751 32.4336H32.4668C33.2295 32.4336 33.8692 32.1752 34.386 31.6584C34.9028 31.1416 35.1603 30.5027 35.1585 29.7419V21.6667C35.1585 20.904 34.9001 20.2652 34.3833 19.7502C33.8665 19.2351 33.2277 18.9767 32.4668 18.9749H24.3916V16.2832H32.4668C33.2295 16.2832 33.8692 16.0248 34.386 15.508C34.9028 14.9912 35.1603 14.3523 35.1585 13.5915C35.1585 12.8288 34.9001 12.19 34.3833 11.675C33.8665 11.1599 33.2277 10.9015 32.4668 10.8997H29.7751C29.7751 10.1371 29.5167 9.49825 28.9998 8.98323C28.483 8.46821 27.8442 8.2098 27.0833 8.20801C26.3207 8.20801 25.6818 8.46641 25.1668 8.98323C24.6518 9.50004 24.3934 10.1389 24.3916 10.8997H21.6999C20.9372 10.8997 20.2984 11.1581 19.7834 11.675C19.2683 12.1918 19.0099 12.8306 19.0081 13.5915V21.6667C19.0081 22.4293 19.2665 23.0691 19.7834 23.5859C20.3002 24.1027 20.939 24.3602 21.6999 24.3584H29.7751V27.0501ZM5.54948 43.2005C4.06903 43.2005 2.80212 42.6738 1.74875 41.6205C0.69539 40.5671 0.16781 39.2993 0.166016 37.8171V5.51628C0.166016 4.03582 0.693595 2.76891 1.74875 1.71555C2.80391 0.662186 4.07082 0.134607 5.54948 0.132812H48.6172C50.0976 0.132812 51.3654 0.660392 52.4206 1.71555C53.4758 2.77071 54.0024 4.03762 54.0006 5.51628V37.8171C54.0006 39.2975 53.474 40.5653 52.4206 41.6205C51.3672 42.6756 50.0994 43.2023 48.6172 43.2005H5.54948ZM5.54948 37.8171H48.6172V5.51628H5.54948V37.8171Z\" fill=\"#7857E6\"/>\r\n                    </svg>"
                    }
                ]
            }
        ]
    }
}